// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { eachDayOfInterval as fn } from "../eachDayOfInterval.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const eachDayOfInterval = convertToFP(fn, 1);

// Fallback for modularized imports:
export default eachDayOfInterval;
